import { motion } from "./motion";

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`inline-block font-['Inter'] text-xs md:text-sm font-bold uppercase tracking-[0.22em] text-[#C9A84C] ${className}`}>
    {children}
  </span>
);

export const CTA = ({ children, variant = "gold", onClick, href, testid, className = "" }) => {
  const base =
    "inline-flex items-center justify-center gap-2 font-['Inter'] font-bold tracking-wide rounded-full px-7 py-3.5 text-sm md:text-base transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A84C] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D0D0F]";
  const styles =
    variant === "gold"
      ? "bg-[#C9A84C] text-[#0D0D0F] hover:bg-[#E5C365] hover:scale-[1.04] shadow-[0_10px_34px_rgba(201,168,76,0.34)]"
      : "bg-white/[0.04] border border-[#2A2A35] text-[#F0F0F0] hover:border-[#C9A84C]/60 hover:bg-white/[0.07]";
  const cls = `${base} ${styles} ${className}`;
  if (href) return <a href={href} className={cls} data-testid={testid}>{children}</a>;
  return <button type="button" onClick={onClick} className={cls} data-testid={testid}>{children}</button>;
};

export const GlowOrb = ({ className = "", color = "rgba(201,168,76,0.18)" }) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute rounded-full blur-[120px] ${className}`}
    style={{ background: color }}
  />
);

export const Logo = ({ className = "h-8" }) => (
  <img
    src="/assets/sparkcue-logo.png?v=4"
    alt="SparkCue"
    className={`${className} w-auto object-contain select-none bg-transparent`}
    style={{ background: "transparent" }}
    draggable="false"
  />
);

export const ChatBubble = ({ from, text, gold }) => {
  const me = from === "you";
  return (
    <div
      className={`px-4 py-2.5 rounded-2xl max-w-[82%] font-['Inter'] text-[13px] sm:text-sm leading-snug ${
        me
          ? "ml-auto bg-[#C9A84C] text-[#0D0D0F] font-medium rounded-br-md shadow-[0_4px_16px_rgba(201,168,76,0.3)]"
          : "mr-auto bg-[#23232b] text-[#F0F0F0] rounded-bl-md border border-[#2A2A35]"
      } ${gold ? "ring-1 ring-[#C9A84C]/30" : ""}`}
    >
      {text}
    </div>
  );
};

// Realistic device frame wrapper.
export const PhoneFrame = ({ children, className = "" }) => (
  <div className={`relative mx-auto w-[270px] sm:w-[300px] ${className}`}>
    <div className="relative rounded-[2.6rem] bg-[#0a0a0c] border border-[#2A2A35] p-2.5 shadow-[0_40px_90px_-20px_rgba(0,0,0,0.8),0_0_0_1px_rgba(201,168,76,0.08)]">
      <div className="relative rounded-[2.1rem] overflow-hidden bg-[#0D0D0F] h-[560px] sm:h-[600px]">
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-5 bg-[#0a0a0c] rounded-full z-20" />
        {children}
      </div>
    </div>
  </div>
);
